import { isWatchGachaMachine } from "./gacha-data"
import packArtMap from "./gacha-pack-art-map.json"

export type WatchRevealPlan =
  | {
      kind: "generic"
    }
  | {
      kind: "watch-single"
      boxSrc: string
      glowSrc: string
      glowStartsAtMs: 864
      cardStartsAtMs: 2500
      cardFadeDurationMs: 500
      glowEndsAtMs: 5266
      handoffAtMs: 6100
    }
  | {
      kind: "watch-multi"
      boxSrc: string
      flashStartsAtMs: 2000
      handoffAtMs: 2450
    }

type CreateWatchRevealPlanOptions = {
  machineCode?: string
  packCount: number
  rarity?: string
}

type WatchRevealRarity = "common" | "uncommon" | "rare" | "epic"

const WATCH_OPENED_BOX_SOURCES: Record<string, string> =
  packArtMap.watchReveal.openedBoxVideos
const WATCH_GLOW_SOURCES: Record<WatchRevealRarity, string> =
  packArtMap.watchReveal.glowVideos

function getWatchGlowSrc(rarity: string | undefined) {
  const normalizedRarity = rarity?.toLowerCase()

  if (
    normalizedRarity === "uncommon" ||
    normalizedRarity === "rare" ||
    normalizedRarity === "epic"
  ) {
    return WATCH_GLOW_SOURCES[normalizedRarity]
  }

  return WATCH_GLOW_SOURCES.common
}

export function getWatchRevealPreloadSources(machineCode?: string) {
  if (!machineCode || !isWatchGachaMachine(machineCode)) return []

  return [
    WATCH_OPENED_BOX_SOURCES[machineCode],
    ...Object.values(WATCH_GLOW_SOURCES),
  ]
}

export function createWatchRevealPlan({
  machineCode,
  packCount,
  rarity,
}: CreateWatchRevealPlanOptions): WatchRevealPlan {
  if (!machineCode || !isWatchGachaMachine(machineCode)) {
    return { kind: "generic" }
  }

  const boxSrc = WATCH_OPENED_BOX_SOURCES[machineCode]

  if (packCount > 1) {
    return {
      kind: "watch-multi",
      boxSrc,
      flashStartsAtMs: 2000,
      handoffAtMs: 2450,
    }
  }

  if (packCount !== 1) return { kind: "generic" }

  return {
    kind: "watch-single",
    boxSrc,
    glowSrc: getWatchGlowSrc(rarity),
    glowStartsAtMs: 864,
    cardStartsAtMs: 2500,
    cardFadeDurationMs: 500,
    glowEndsAtMs: 5266,
    handoffAtMs: 6100,
  }
}
